import api from "./api";

export const getDoctorProfile = () =>
  api.get("/doctor/profiles/");

export const getPatientEnrollments = (params = {}) =>
  api.get("/doctor/enrollments/", { params });

export const enrollPatient = (data) =>
  api.post("/doctor/enrollments/", data);

export const getPatients = () =>
  api.get("/patient/profiles/");

export const getPatientProfiles = () =>
  api.get("/patient/profiles/");

export const getPrescriptions = () =>
  api.get("/pharmacy/prescriptions/");

export const createPrescription = (data) => {
  console.log('API call data:', JSON.stringify(data, null, 2));
  return api.post("/pharmacy/prescriptions/", data);
};

export const registerPatient = (data) =>
  api.post("/accounts/register-patient/", data);

export const getBillingRecords = () =>
  api.get("/billing/records/");

export const createBillingRecord = (data) =>
  api.post("/billing/records/", data);

export const getDiagnoses = (params = {}) =>
  api.get("/doctor/diagnoses/", { params });

export const createDiagnosis = (data) =>
  api.post("/doctor/diagnoses/", data);

export const updateDiagnosis = (id, data) =>
  api.patch(`/doctor/diagnoses/${id}/`, data);

export const getPatientHistory = (patientProfileId) =>
  api.get(`/doctor/patient-history/${patientProfileId}/`);

export const getPatientHistoryByPin = (patientPin) =>
  api.get(`/doctor/patient-history/by-pin/${patientPin}/`);

// @deprecated — retained for backwards compatibility.
export const getMedicalShares = () =>
  api.get("/doctor/medical-shares/");

// Returns all verified pharmacy profiles — doctors use this to direct prescriptions.
export const getPharmacies = () =>
  api.get("/pharmacy/profiles/");

// ── Doctor network directory (for peer chat / consultation recipient search) ──
export const getDoctorNetwork = () =>
  api.get("/doctor/profiles/");

export const searchDoctorPeers = (search = "") =>
  api.get("/doctor/peers/", { params: search ? { search } : {} });

export const searchPatients = (search = "") =>
  api.get("/doctor/patient-search/", { params: search ? { search } : {} });

// ── Notifications ─────────────────────────────────────────────────────────────
export const getNotifications = () =>
  api.get("/doctor/notifications/");

export const getNotificationUnreadCount = () =>
  api.get("/doctor/notifications/unread-count/");

export const markNotificationsRead = (notificationIds) =>
  api.post("/doctor/notifications/mark-read/", {
    notification_ids: notificationIds,
  });

export const markAllNotificationsRead = () =>
  api.post("/doctor/notifications/mark-all-read/");

// ── Peer Chat ─────────────────────────────────────────────────────────────────
export const getPeerChats = () =>
  api.get("/doctor/peer-chats/");

export const startPeerChat = (doctorId) =>
  api.post("/doctor/peer-chats/", { doctor_id: doctorId });

export const getChatMessages = (chatId) =>
  api.get(`/doctor/peer-chats/${chatId}/messages/`);

export const sendChatMessage = (chatId, content) =>
  api.post(`/doctor/peer-chats/${chatId}/messages/`, { content });

// ── Consultation Cases ────────────────────────────────────────────────────────
export const getConsultations = () =>
  api.get("/doctor/consultations/");

// ── Adopted Patients ─────────────────────────────────────────────────────────
export const getAdoptedPatients = () =>
  api.get("/doctor/adopted-patients/");

export const adoptPatient = (patientProfileId) =>
  api.post("/doctor/adopted-patients/adopt/", { patient_profile_id: patientProfileId });

export const getSharedWithMe = () =>
  api.get("/patient/share-consents/shared-with-me/");

// ── Network Directory ─────────────────────────────────────────────────────────
export const getNetworkHospitals = () =>
  api.get("/operations/network/hospitals/");

export const getNetworkDoctors = () =>
  api.get("/operations/network/doctors/");

export const getConsultation = (id) =>
  api.get(`/doctor/consultations/${id}/`);

export const createConsultation = (data) =>
  api.post("/doctor/consultations/", data);

export const updateConsultation = (id, data) =>
  api.patch(`/doctor/consultations/${id}/`, data);

export const getConsultationReplies = (id) =>
  api.get(`/doctor/consultations/${id}/replies/`);

export const replyToConsultation = (id, content) =>
  api.post(`/doctor/consultations/${id}/replies/`, { content });

// ── Appointments ──────────────────────────────────────────────────────────────
export const getAppointments = (params = {}) =>
  api.get("/doctor/appointments/", { params });

export const createAppointment = (data) =>
  api.post("/doctor/appointments/", data);

export const updateAppointment = (id, data) =>
  api.patch(`/doctor/appointments/${id}/`, data);

export const deleteAppointment = (id) =>
  api.delete(`/doctor/appointments/${id}/`);

export const respondAppointment = (id, data) =>
  api.post(`/doctor/appointments/${id}/respond/`, data);
